<div class="location-step-container">
  <div class="map">
    <c-google-map
      [center]="mapCenter"
      [zoom]="zoom"
      [mapRadius]="mapRadius"
      [currentLocationActive]="currentLocationUsed()"
      (currentLocationRequested)="requestCurrentLocation()" />
  </div>

  @if (title()) {
    <h2 class="ion-no-margin">{{ title() }}</h2>
  }

  @if (description()) {
    <p class="ion-no-margin">{{ description() }}</p>
  }

  <form [formGroup]="form">
    <c-autocomplete
      [label]="'dynamic-flow.location-step.location' | transloco"
      [control]="form.controls.location"
      [list]="locationSuggestions"
      (itemSelected)="selectLocation($event)" />

    <c-input
      type="text"
      inputMode="numeric"
      [label]="'dynamic-flow.location-step.distance' | transloco"
      formControlName="distanceInKm" />
  </form>

  <p class="disclaimer">{{ 'dynamic-flow.location-step.distance-note' | transloco }}</p>
</div>
